








import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import {
  retrievePrivacyPolicy,
  getPrivacyPolicyHtml
} from '@/api/privacy-policy'
import sanitizeHTML from 'sanitize-html'

@Component({
  name: 'PrivacyPolicyPage'
})
export default class PrivacyPolicyPage extends Vue {
  @Prop({ default: '' }) private medicalBusinessId!: string
  @Prop({ default: '' }) private clinicId!: string
  private content = ''

  @Watch('medicalBusinessId', { immediate: true })
  @Watch('clinicId', { immediate: true })
  private async onMedicalBusinessIdAndClinicIdChange() {
    if (!this.medicalBusinessId || !this.clinicId) return
    const privacyPolicy = await retrievePrivacyPolicy(
      this.medicalBusinessId,
      this.clinicId
    )
    const contentUrl = privacyPolicy.file_url
      ? privacyPolicy.file_url
      : privacyPolicy.default_file_url
    const result = await getPrivacyPolicyHtml(contentUrl)
    this.content = result || ''
  }

  private get sanitizeText() {
    return sanitizeHTML(this.content, {
      allowedTags: false as const,
      allowedAttributes: false as const,
      allowedSchemes: ['http', 'https', 'data']
    })
  }
}
